import { Component, contentChild, input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
  host: {
    class: 'flex gap-4 items-start p-4 rounded-lg border border-100',
  },
})
export class AlertComponent {
  title = input<string>();
  message = input.required<string>();

  iconTemplate = contentChild<TemplateRef<unknown>>('icon');
}
